import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useImageListContext} from './context';
import styles from './dot-indicators.module.css';

export function ImageListDotIndicators() {
  const {currentSlidePage, setCurrentSlidePage, total} = useImageListContext();

  function createOnClick(index: number) {
    return () => {
      setCurrentSlidePage(index);
    };
  }

  if (total === 1) return null;

  return (
    <div
      className={clsx(
        styles.dots,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {Array.from({length: total}, (_, index) => index).map((index) => (
        <Dot
          key={index}
          index={index}
          isActive={currentSlidePage === index + 1}
          onClick={createOnClick(index + 1)}
        />
      ))}
    </div>
  );
}

type DotProps = {
  readonly index: number;
  readonly isActive: boolean;
  readonly onClick: () => void;
};

function Dot({index, isActive, onClick}: DotProps) {
  return (
    <button
      type='button'
      className={clsx(styles.dot, isActive && styles.dotActive)}
      aria-label={`${index + 1}ページ目に移動`}
      onClick={onClick}
    />
  );
}
